export class DeleteFormAction {
  public static readonly type = '[Project/Forms/List] DeleteFormAction';
  constructor(public readonly id: string) {}
}
